import React, { useState,useEffect } from "react";
import AOS from "aos";
import Portfolios from "./PortfolioServer";
import { Link } from "react-router-dom";
import "./Portfolio.css";
import OpacityLoading from "../Loading/OpacityLoading";
function Portfolio() {
  const [portItem, setPortItem] = useState(Portfolios);

  const ControlHandlar = (item) => {
    const UpdatePortfolio = Portfolios.filter(
      (catItem) => catItem.cat === item
    );
    setPortItem(UpdatePortfolio);
  };

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <>
      <OpacityLoading>
        <div>
          <div>
            <div className="portfolio-hero">
              <h1 data-aos="fade-right">my lovely portfolio</h1>
            </div>
            <div>
              <div className="text-center portfolio-project-title">
                <h3>Some project</h3>
                <p>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Asperiores, excepturi. Minima, <br /> obcaecati quis qui at
                  quam mollitia natus atque voluptatem.
                </p>
              </div>
              <div class="portfolio_filter">
                <ul>
                  <li>
                    <Link
                      href="#"
                      class="current"
                      onClick={() => setPortItem(Portfolios)}
                    >
                      All
                    </Link>
                  </li>
                  <li>
                    <Link href="#" onClick={() => ControlHandlar("e-com")}>
                      E-Commerce
                    </Link>
                  </li>
                  <li>
                    <Link href="#" onClick={() => ControlHandlar("portfolio")}>
                      Portfolio
                    </Link>
                  </li>
                  <li>
                    <Link href="#" onClick={() => ControlHandlar("react")}>
                      React_admin
                    </Link>
                  </li>
                  <li>
                    <Link href="#" onClick={() => ControlHandlar("practice")}>
                      practies_project
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className=" container gallery" data-aos="fade-up">
              {portItem.map((item) => {
                return (
                  <div className="pices" key={item.id}>
                    <img src={item.image} width="100%" alt="" />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="container-fluid">
            <div className="port-title text-center">
              <span>From My leatest Project</span>
              <h3>
                Our Recent Updates, Blog, Tips, <br /> Tricks &amp; More
              </h3>
            </div>
            <div className="port-description">
              <div className=" row">
                <div className="col-sm-12 col-md-7 col-lg-8 my-md-2  ">
                  <div className="port-1-text px-md-5 px-2 py-3" data-aos="fade-right">
                    <h2>E-Commerce Project</h2>
                    <p>
                      One of my most challenging and amusing experiences in
                      e-commerce was working on a project for a client who sold
                      novelty toilet brushes. My task was to write the product
                      descriptions in a funny and engaging way. I spent hours
                      brainstorming puns and clever phrases to make the
                      descriptions stand out. <br /><br /> The process was quite difficult,
                      as I had to balance being creative and funny with
                      providing enough information about the product. But the
                      end result was worth it. The client loved the descriptions
                      and even used my line "Cleanliness is next to brushliness"
                      in their advertising campaign. It was a great experience
                      and I learned that sometimes, putting in extra effort and
                      thinking outside the box can lead to truly unique and
                      successful projects. It was also a reminder that a little
                      bit of humor can go a long way in making a project stand
                      out."
                    </p>
                    <div className="d-flex ">
                      <h6>Hasanul Haque ~</h6>
                      <span>Nov-12-2022</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-5  col-lg-4 my-5" data-aos="flip-right">
                  <div className="port-img">
                    <img
                      src="images/e-com1.png"
                      alt="blog"
                      style={{ height: "274px" }}
                    />
                  </div>
                </div>
              </div>

              <div className="row port-ownStyle">
                <div className="col-sm-12 col-md-5  col-lg-4 my-5" data-aos="flip-left">
                  <div className="port-img">
                    <img
                      src="images/portfolio.png"
                      alt="blog"
                      style={{ height: "274px" }}
                    />
                  </div>
                </div>

                <div className="col-sm-12 col-md-7 col-lg-8 my-md-2  ">
                  <div className="port-1-text px-md-5 px-2 py-3" data-aos="fade-left">
                    <h2> last Portfolio </h2>
                    <p>
                      One of the most entertaining experiences I had while
                      working on a portfolio project was when I decided to add a
                      "Easter egg" to the website. It was a hidden button that,
                      when clicked, would trigger a playful animation of a
                      dancing banana. <br /> It was a small touch but it added a
                      bit of humor and personality to the website. It was a hit
                      among the team and clients and was a great way to showcase
                      our creativity and sense of humor. It's funny how small
                      things can make a big impact and this small feature was
                      one of the client's favourite thing about the website. It
                      was a great reminder that sometimes it's the little
                      details that can make a project truly stand out.
                    </p>
                    <div className="d-flex ">
                      <h6>ziaul haque ~</h6>
                      <span>jan-12-2022</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </OpacityLoading>
    </>
  );
}

export default Portfolio;
